'use client';

import { useEffect, useMemo, useState } from 'react';

import type { NavItem } from '../../types/navigation';

const shouldMarkAsActive = (href: string, pathname: string): boolean => {
  if (!href.startsWith('/')) return false;
  if (pathname === href) return true;
  return pathname.startsWith(`${href}/`);
};

const useBrowserPathname = (enabled: boolean): string | null => {
  const [pathname, setPathname] = useState<string | null>(null);

  useEffect(() => {
    if (enabled) setPathname(window.location.pathname);
  }, [enabled]);

  return pathname;
};

const useHeaderNavigation = (rawNavItems: NavItem[], pathnameProp?: string) => {
  const browserPathname = useBrowserPathname(pathnameProp === undefined);
  const pathname = pathnameProp ?? browserPathname;

  const navItems = useMemo<NavItem[]>(
    () =>
      rawNavItems.map((item) => ({
        ...item,
        active: item.active ?? shouldMarkAsActive(item.href, pathname ?? ''),
      })),
    [rawNavItems, pathname],
  );

  return {
    navItems,
    pathname,
  };
};

export default useHeaderNavigation;
